import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl, FormControl, ValidatorFn } from '@angular/forms';
import { Router, ActivatedRoute, provideRoutes } from '@angular/router';
import { WMS } from 'src/app/classes/device';
import { DashboardService } from '../dashboard.service';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MustMatch } from 'src/app/data-service/must-match.validator';
@Component({
  selector: 'app-add-epc-dg-user',
  templateUrl: './add-epc-dg-user.component.html',
  styleUrls: ['./add-epc-dg-user.component.scss']
})
export class AddEpcDgUserComponent implements OnInit {

  private ResponseVerifiedAddDg$: Subject<any> = new Subject();
  private ResponseVerifiedUpdateDg$: Subject<any> = new Subject();
  private ResponseVerifiedGetDgInfo$: Subject<any> = new Subject();
  private ResponseVerifiedGetDevice$: Subject<any> = new Subject();
  dgInfo = new WMS();
  pipe = new DatePipe('en-US')
  addDgForm: FormGroup;
  message: string;
  DeviceList: any;
  deviceId: any;
  userId: any;
  isEditing: any;
  deviceEpcId: any;
  editUserObject: any = {};
  dataObject: any = [];
  role: any;
  roleName: string;
  deviceObject: any = {};
  addenergy_meter: any;
  energy_meter = false;
  marked = false;
  wms = false;
  addWms: any;
  graph_inv: any;
  time: any = [{ "id": "14" }, { "id": "13" }, { "id": "12" }, { "id": "11" }, { "id": "10" }, { "id": "9" }, { "id": "8" }, { "id": "7" }, { "id": "6" }, { "id": "5" }, { "id": "4" }, { "id": "3" }, { "id": "2" }, { "id": "1" }];
  constructor(private fb: FormBuilder, private router: Router, private route: ActivatedRoute, private dashbord: DashboardService, private toastr: ToastrService) {
    this.role = localStorage.role;
    if (this.role == '1') {
      this.roleName = 'admin';
    } else if (this.role == '2') {
      this.roleName = 'epc';
    }

    this.route.queryParams.subscribe(params => {
      if (params.id) {
        this.isEditing = true;
        this.userId = params.id;
      }
    });

  }

  ngOnInit() {
    if (this.roleName == 'epc') {
      // this.getDeviceList();
    }
    if (this.roleName == 'epc' && this.isEditing == true) {
      this.getInfoByUserId();
    }

    this.addDgForm = this.fb.group({
      // We can set default values by passing in the corresponding value or leave blank if we wish to not set the value. For our example, we’ll default the gender to female.

      login_id: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      email: ['', [Validators.pattern("[A-Za-z0-9._%+-]{1,}@[a-zA-Z0-9]{1,}([.]{1}[a-zA-Z0-9]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})")]],
      password: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      mobile_no: ['', [Validators.pattern("^[0-9]*$"), Validators.minLength(10), Validators.maxLength(10)]],
      sim_no: ['', [Validators.pattern("^[0-9]*$"), Validators.minLength(10), Validators.maxLength(10)]],
      address: ['', [Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      instd_capacity: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,3})?$")]],
      num_inverter: ['', [Validators.required, Validators.pattern("^[0-9]*$")]],
      elec_rate: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,2})?$")]],
      start_dt: ['', Validators.required],
      end_dt: ['', Validators.required],
      solar_panel: ['', [Validators.pattern("^[a-zA-Z0-9]+$")]],
      num_solar_panel: ['', [Validators.required, Validators.pattern("^[0-9]*$")]],
      area_solar_panel: [null, [ Validators.pattern("^[0-9]+(.[0-9]{0,2})?$")]],
      eff_solar_panel: [null, [Validators.pattern("^[0-9]+(.[0-9]{0,2})?$")]],
      t_coeff_v: [null, [ Validators.pattern("^[0-9]+(.[0-9]{0,2})?$")]],
      t_coeff_p: [null, [ Validators.pattern("^[0-9]+(.[0-9]{0,2})?$")]],
      confirmPassword: ['', Validators.required],
      wms: [''],
      energy_meter: [''],
      graph_interval: [''],
     // dg_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
     // dg_rating: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,2})?$")]],
    }, {
        validator: MustMatch('password', 'confirmPassword')
      }
    );

  }
  get f() { return this.addDgForm.controls; }

  add_dg() {
    if (this.addDgForm.value.wms == true || this.addDgForm.value.wms == 'true') {
      this.addWms = 1;
    } else if (this.addDgForm.value.wms == false || this.addDgForm.value.wms == 'false') {
      this.addWms = 0;
    }
    if (this.addDgForm.value.graph_interval == "") {
      this.graph_inv = "15";
    } else {
      this.graph_inv = this.addDgForm.value.graph_interval;
    }
    if (this.addDgForm.value.energy_meter == true || this.addDgForm.value.energy_meter == 'true') {
      this.addenergy_meter = 1;
    } else if (this.addDgForm.value.energy_meter == false || this.addDgForm.value.energy_meter == 'false') {
      this.addenergy_meter = 0;
    }
    var dgInfo =
    {
      "login_id": this.addDgForm.controls['login_id'].value,
      "name": this.addDgForm.controls['name'].value,
      "email": this.addDgForm.controls['email'].value,
      "password": this.addDgForm.controls['password'].value,
      "mobile_no": this.addDgForm.controls['mobile_no'].value,
      "sim_no": this.addDgForm.controls['sim_no'].value,
      "address": this.addDgForm.controls['address'].value,
      "instd_capacity": this.addDgForm.controls['instd_capacity'].value,
      "num_inverter": this.addDgForm.controls['num_inverter'].value,
      "elec_rate": this.addDgForm.controls['elec_rate'].value,
      "start_dt": this.pipe.transform(this.addDgForm.controls['start_dt'].value, "yyyy-MM-dd"),
      "end_dt": this.pipe.transform(this.addDgForm.controls['end_dt'].value, "yyyy-MM-dd"),
      "solar_panel": this.addDgForm.controls['solar_panel'].value,
      "num_solar_panel": this.addDgForm.controls['num_solar_panel'].value,
      "area_solar_panel": this.addDgForm.controls['area_solar_panel'].value,
      "eff_solar_panel": this.addDgForm.controls['eff_solar_panel'].value,
      "t_coeff_v": this.addDgForm.controls['t_coeff_v'].value,
      "t_coeff_p": this.addDgForm.controls['t_coeff_p'].value,
      "is_emeter": this.addenergy_meter,
      "is_wms": this.addWms,
    //  "dg_name": this.addDgForm.controls['dg_name'].value,
    //  "dg_rating": this.addDgForm.controls['dg_rating'].value,
      "graph_interval": this.graph_inv
    }
    this.dashbord.addEpcDg(dgInfo)
      .pipe(takeUntil(this.ResponseVerifiedAddDg$))
      .subscribe(data => {
        if (data.status === true || data.status === 'true') {
          this.toastr.success(data.message);
          this.router.navigate(['/inject-solar/register-epc-users/epc-dg-users']);

        } else if (!data.status) {
          if (data.message == 'Unauthorised or Login Time-out') {
            this.toastr.info(data.message);
            this.router.navigate(["/login"]);

          } else {
            this.toastr.info(data.message);

          }
        }
      },
        err => {
          return console.log(err);
        })
  }

  update_dg() {
    if (this.addDgForm.value.energy_meter == true || this.addDgForm.value.energy_meter == 'true') {
      this.addenergy_meter = 1;
    } else if (this.addDgForm.value.energy_meter == false || this.addDgForm.value.energy_meter == 'false') {
      this.addenergy_meter = 0;
    }
    if (this.addDgForm.value.wms == true || this.addDgForm.value.wms == 'true') {
      this.addWms = 1;
    } else if (this.addDgForm.value.wms == false || this.addDgForm.value.wms == 'false') {
      this.addWms = 0;
    }
    var dgInfo =
    {
      "id": this.userId,
      "login_id": this.addDgForm.controls['login_id'].value,
      "name": this.addDgForm.controls['name'].value,
      "email": this.addDgForm.controls['email'].value,
      "mobile_no": this.addDgForm.controls['mobile_no'].value,
      "sim_no": this.addDgForm.controls['sim_no'].value,
      "address": this.addDgForm.controls['address'].value,
      "instd_capacity": this.addDgForm.controls['instd_capacity'].value,
      "num_inverter": this.addDgForm.controls['num_inverter'].value,
      "elec_rate": this.addDgForm.controls['elec_rate'].value,
      "start_dt": this.pipe.transform(this.addDgForm.controls['start_dt'].value, "yyyy-MM-dd"),
      "end_dt": this.pipe.transform(this.addDgForm.controls['end_dt'].value, "yyyy-MM-dd"),
      "solar_panel": this.addDgForm.controls['solar_panel'].value,
      "num_solar_panel": this.addDgForm.controls['num_solar_panel'].value,
      "area_solar_panel": this.addDgForm.controls['area_solar_panel'].value,
      "eff_solar_panel": this.addDgForm.controls['eff_solar_panel'].value,
      "t_coeff_v": this.addDgForm.controls['t_coeff_v'].value,
      "t_coeff_p": this.addDgForm.controls['t_coeff_p'].value,
    //  "dg_name": this.addDgForm.controls['dg_name'].value,
    //  "dg_rating": this.addDgForm.controls['dg_rating'].value,
      "is_emeter": this.addenergy_meter,
      "is_wms": this.addWms,
      "graph_interval": this.addDgForm.controls['graph_interval'].value,
    }
    this.dashbord.updateDgUser(dgInfo).pipe(takeUntil(this.ResponseVerifiedUpdateDg$))
      .subscribe(data => {
        if (data.status === true || data.status === 'true') {
          this.toastr.success(data.message);
          this.router.navigate(['/inject-solar/register-epc-users/epc-dg-users']);
        } else if (!data.status) {
          if (data.message == 'Unauthorised or Login Time-out') {
            this.toastr.info(data.message);
            this.router.navigate(["/login"]);
          } else {
            this.toastr.info(data.message);
          }
        }
      },
        err => {
          return console.log(err);
        })
  }


  getInfoByUserId() {
    this.editUserObject = {
      id: this.userId
    };
    this.dashbord.getInfoByEpcDgUserId(this.editUserObject)
      .pipe(takeUntil(this.ResponseVerifiedGetDgInfo$))
      .subscribe(
        async data => {
          if (data.status) {
            this.editUserObject = {};
            this.dataObject = data.resultObject;
          /*  var editlogin_id = data.resultObject[0].login_id;
            var editName = this.dataObject[0].name;
            var editDGName = this.dataObject[0].dg_name;
            var editDGRating = this.dataObject[0].dg_rating;
            var editEmail = this.dataObject[0].email;
            var editMobileNo = this.dataObject[0].mobile_no;
            var editAddress = this.dataObject[0].address;
            var editInstdCapacity = this.dataObject[0].instd_capacity;
            var editNumInverter = this.dataObject[0].num_inverter;
            var editElecRate = this.dataObject[0].elec_rate;
            var editStartDate = this.dataObject[0].start_dt;
            var editEndDate = this.dataObject[0].end_dt;
            var editSolarPanel = this.dataObject[0].solar_panel;
            var editNumSolarPanel = this.dataObject[0].num_solar_panel;
            var editAreaSolarPanel = this.dataObject[0].area_solar_panel;
            var editEffSolarPanel = this.dataObject[0].eff_solar_panel;
            var editCoeffV = this.dataObject[0].t_coeff_v;
            var editCoeffT = this.dataObject[0].t_coeff_p;
            var editGraph_interval = data.resultObject[0].graph_interval;*/

            var editEnergyMeter = data.resultObject[0].is_emeter;
            var editWms = data.resultObject[0].is_wms;

            if (editEnergyMeter == 0) {
              this.marked = false;
              this.toggleVisibility(this.marked);
            } else if (editEnergyMeter == 1) {
              this.marked = true;
              this.toggleVisibility(this.marked);
            }
            if (editWms == 0) {
              this.marked = false;
              this.toggleVisibilityDg(this.marked);
            } else if (editWms == 1) {
              this.marked = true;
              this.toggleVisibilityDg(this.marked);
            }
            // set value on the from
            this.addDgForm.get('login_id').setValue(data.resultObject[0].login_id);
            this.addDgForm.get('name').setValue(this.dataObject[0].name);
            this.addDgForm.get('email').setValue(this.dataObject[0].email);
            this.addDgForm.get('mobile_no').setValue(this.dataObject[0].mobile_no);
            this.addDgForm.get('sim_no').setValue(this.dataObject[0].sim_no);
            this.addDgForm.get('address').setValue(this.dataObject[0].address);
            this.addDgForm.get('instd_capacity').setValue(this.dataObject[0].instd_capacity);
            this.addDgForm.get('num_inverter').setValue(this.dataObject[0].num_inverter);
            this.addDgForm.get('elec_rate').setValue( this.dataObject[0].elec_rate);
            this.addDgForm.get('start_dt').setValue(this.dataObject[0].start_dt);
            this.addDgForm.get('end_dt').setValue(this.dataObject[0].end_dt);
            this.addDgForm.get('solar_panel').setValue(this.dataObject[0].solar_panel);
            this.addDgForm.get('num_solar_panel').setValue(this.dataObject[0].num_solar_panel);
            this.addDgForm.get('area_solar_panel').setValue(this.dataObject[0].area_solar_panel);
            this.addDgForm.get('eff_solar_panel').setValue(this.dataObject[0].eff_solar_panel);
            this.addDgForm.get('t_coeff_v').setValue(this.dataObject[0].t_coeff_v);
            this.addDgForm.get('t_coeff_p').setValue(this.dataObject[0].t_coeff_p);
            this.addDgForm.get('graph_interval').setValue(data.resultObject[0].graph_interval);
          //  this.addDgForm.get('dg_name').setValue(this.dataObject[0].dg_name);
          //  this.addDgForm.get('dg_rating').setValue(this.dataObject[0].dg_rating);
            this.addDgForm.get('password').setValue("password");
            this.addDgForm.get('confirmPassword').setValue("password");
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  //get device list
  // getDeviceList() {

  //   this.dashbord.getAllUserDevice()
  //     .pipe(takeUntil(this.ResponseVerifiedGetDevice$))
  //     .subscribe(
  //       async data => {
  //         if (data.status) {
  //           this.DeviceList = data.resultObject;

  //         } else if (!data.status) {
  //           if (data.message == 'Unauthorised or Login Time-out') {
  //             this.toastr.info(data.message);
  //             this.router.navigate(["/login"]);

  //           } else {
  //             this.toastr.info(data.message);

  //           }
  //         }
  //       },
  //       err => {
  //         return console.error(err);
  //       }
  //     );
  // }


  toggleVisibility(e) {
    if (e === false) {
      this.marked = false;
      this.energy_meter = false;
    } else if (e == true) {
      this.marked = true;
      this.energy_meter = true;
    }
  }
  toggleVisibilityDg(e) {
    if (e === false) {
      this.marked = false;
      this.wms = false;
    } else if (e == true) {
      this.marked = true;
      this.wms = true;
    }
  }
  changeTime(e) {
  }
  ngOnDestroy() {
    this.ResponseVerifiedUpdateDg$.next();
    this.ResponseVerifiedUpdateDg$.complete();
    this.ResponseVerifiedAddDg$.next();
    this.ResponseVerifiedAddDg$.complete();
    this.ResponseVerifiedGetDgInfo$.next();
    this.ResponseVerifiedGetDgInfo$.complete();
    this.ResponseVerifiedGetDevice$.next();
    this.ResponseVerifiedGetDevice$.complete();
  }
}
